import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { Provider as ReduxProvider } from 'react-redux';
import { configureStore } from './redux/store';
import { ToastProvider } from 'react-toast-notifications';
import ToastContainer from './components/ToastContainer';
import Provider from './context/index';
import history from './history';
import { ThemeProvider } from 'styled-components';
import { theme } from './constants/theme';
import { AnimatePresence } from 'framer-motion';
import { RecoilRoot } from 'recoil';
import { Auth0Provider } from "@auth0/auth0-react";
import { SocketProvider } from './context/SocketContextFile';

const onRedirectCallback = (appState) => {
    history.push(
        appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};

// Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
// for a full list of the available properties on the provider

const { REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT, REACT_APP_AUTH0_AUDIENCE } = process.env;

const providerConfig = {
    domain: REACT_APP_AUTH0_DOMAIN,
    clientId: REACT_APP_AUTH0_CLIENT,
    onRedirectCallback,
    authorizationParams: {
        redirect_uri: window.location.origin,
        ...(REACT_APP_AUTH0_AUDIENCE ? { audience: REACT_APP_AUTH0_AUDIENCE } : null),
    },
};

const App = React.lazy(() => import(/* webpackChunkName: "App" */'./App'));
const root = createRoot(document.getElementById("root"));


root.render(
    <BrowserRouter history={history}>
        <ReduxProvider store={configureStore()}>
            <Suspense fallback={<div className={`pulse-loading mx-auto`} style={{ height: '200px' }}></div>}>
                <ToastProvider components={{ ToastContainer }}>
                    <Auth0Provider {...providerConfig}>
                        <RecoilRoot>
                            <Provider>
                                <SocketProvider>
                                    <ThemeProvider theme={theme}>
                                        <AnimatePresence>
                                            <App />
                                        </AnimatePresence>
                                    </ThemeProvider>
                                </SocketProvider>
                            </Provider>
                        </RecoilRoot>
                    </Auth0Provider>
                </ToastProvider>
            </Suspense>
        </ReduxProvider>
    </BrowserRouter>
);
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
